import { Box, Divider, ImageListItem, Typography } from '@mui/material';
import React from 'react';
import visaImg from '../../../assets/images/cardTypes/visa.png';
import masterImg from '../../../assets/images/cardTypes/master.png';
import amexImg from '../../../assets/images/cardTypes/amex.png';
import dummy from '../../../assets/images/cardTypes/defailtCard.png'
import Button from '../../../ui/elements/buttons/Button';
import { Card } from '../paymentsType/Card';

interface CardProps {
    card: Card; // Single card
    onRemove: (card: Card) => void;
}

const PaymentCard: React.FC<CardProps> = ({ card, onRemove }) => {

    const getCardImage = (type: string) => {
        switch (type) {
            case 'visa':
                return visaImg;
            case 'mastercard':
                return masterImg;
                case 'amex':
                    return amexImg;
            default:
                return ''; // Optional: Add a default image for unknown types
        }
    };

    return (
        <Box
            p={3}
            pb={1}
            boxShadow={2}
            borderRadius="4px"
            width="360px"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            height="100%"
        >
            {getCardImage(card.brand) &&
            <ImageListItem sx={{ width: 49, height: 20 }}>
                <img src={getCardImage(card.brand)} alt={`${card.brand} card`} />
            </ImageListItem>}

            <Box mt={4}>
                <Typography color="#B6B6B6">CARD NUMBER</Typography>
                <Typography fontSize="21px">**** **** **** {card.last4}</Typography>
                <Typography variant="body2" color="#B6B6B6">
                    Expires {card.exp_month}/{card.exp_year}
                </Typography>
            </Box>

            <Box mt="auto" display="flex" flexDirection="column" alignItems="center" width="100%">
                
            <Divider sx={{ width: '100%', mt: 2 }} />
                <Button
                    background="white"
                    color="red"
                    onClick={() => onRemove(card)} // Trigger removal with card info
                >
                    REMOVE CARD
                </Button>
            </Box>
        </Box>
    );
};

export default PaymentCard;
